import {
  ResourceModel,
  ResourceGetAttributes,
  ResourceModelCreateAttributes,
  ResourceModelUpdateAttributes,
  ResourceCollection,
} from 'src/models/ResourceModel';
import { Notify } from 'quasar';
import {
  ResourceAdapterInteface,
  ListResourcesInput as BaseListResourcesInput,
} from 'src/adapter/ResourceAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListResourcesInput = BaseListResourcesInput;
export class ResourceApiClass {
  adapter: ResourceAdapterInteface;
  constructor(adapter: ResourceAdapterInteface) {
    this.adapter = adapter;
  }
  async listResources(
    conditions: ListResourcesInput
  ): Promise<{ total: number; data: ResourceCollection }> {
    try {
      const res = await this.adapter.listResources(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (resource: ResourceGetAttributes) => new ResourceModel(resource)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getResource(id: string): Promise<ResourceModel> {
    try {
      const resource = await this.adapter.getResource(id);
      return new ResourceModel(resource);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async createResource(
    attributes: ResourceModelCreateAttributes
  ): Promise<ResourceModel> {
    try {
      const resource = await this.adapter.createResource(attributes);
      Notify.create({
        type: 'positive',
        message: '作成しました',
      });
      return new ResourceModel(resource);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateResource(
    id: string,
    attributes: ResourceModelUpdateAttributes
  ): Promise<ResourceModel> {
    try {
      const resource = await this.adapter.updateResource(id, attributes);
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new ResourceModel(resource);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async deleteResource(id: string): Promise<boolean> {
    try {
      const res = this.adapter.deleteResource(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async bulkDeleteResources(ids: string[]): Promise<boolean> {
    Notify.create({
      type: 'positive',
      message: '削除しました',
    });
    return this.adapter.bulkDeleteResources(ids);
  }
  csvUpload(file: File) {
    Notify.create({
      type: 'positive',
      message: 'csvアップロードしました。',
    });
    return this.adapter.csvUpload(file);
  }
}
